import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {AggregatedDeviceState} from 'src/app/domain/devices/aggregated-state/aggregated-device-state';

const initialState = {
  loading: true
};

export const AggregatedDeviceStateStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<AggregatedDeviceState>(),
  withMethods((store) => ({
    setAllEntities(states: AggregatedDeviceState[]) {
      patchState(store, setAllEntities(states), {loading: false});
    },
    setEntity(state: AggregatedDeviceState) {
      patchState(store, setEntity(state));
    },
    reset() {
      patchState(store, initialState);
    }
  }))
);
